import type { Step } from '../../lib/capture/guidance'

/** The six-step rail: separate states, never one "ready" light (Canvas 05 §01). */
export function StepRail({ steps }: { steps: readonly Step[] }) {
  return (
    <ol className="ssteps" aria-label="Progress">
      {steps.map((s) => (
        <li key={s.label} className={`sstep sstep--${s.state}`}>
          <span className="sstep__n" aria-hidden="true">
            {s.n}
          </span>
          <span>{s.label}</span>
          {s.state === 'now' && <span className="visually-hidden"> (current)</span>}
        </li>
      ))}
    </ol>
  )
}
